type AppData = {
  deviceType: 'IOS' | 'ANDROID' | 'WEB';
  // Universal
  appVersion?: string;
  deviceId?: string;
  pushEnabled?: boolean;
  // iOS
  iosDeviceModel?: string;
  iosVersion?: string;
  // Android
  androidManufacturer?: string;
  androidBrand?: string;
  androidModel?: string;
  androidVersion?: string;
};

const useSendAppData = () => {
  return (appData: AppData) =>
    fetch(`${process.env.CONSUMER_API_HOST_REST}/v1/app-data`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ appData }),
      method: 'POST',
    });
};

export default useSendAppData;
